import * as React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import { useSelector } from "react-redux";
import Alert from "@mui/material/Alert";
import { setError } from "../../redux/slices/roles";
import { useDispatch } from "react-redux";
import ReplayIcon from "@mui/icons-material/Replay";

export default function RecoverModal({ handleDelete, params, name }) {
  const { error } = useSelector((state) => state.roles);
  const dispatch = useDispatch();
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    height: "auto",
    borderRadius: 2,
    bgcolor: "background.paper",
    boxShadow: 24,
    p: 2,
    py: 3,
  };

  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => {
    setOpen(false);
    dispatch(setError(false));
  };
  return (
    <div>
      <ReplayIcon onClick={handleOpen} sx={{ color: "#377E3A" }} />
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Typography
            id="modal-modal-title"
            variant="h6"
            component="h2"
            sx={{ color: "green", textAlign: "center", fontSize: 25 }}
          >
            RECUPERAR {name}
          </Typography>
          <Typography id="modal-modal-description" sx={{ mt: 2, textAlign: "center" }}>
            ¿Estas seguro que deseas recuperar {params.row.nombre ? params.row.nombre : params.row.descripcion}?
          </Typography>
          <div className="flex justify-center mt-8">
            <Button
              sx={{ marginRight: 2 }}
              variant="contained"
              onClick={() => {
                handleDelete(params);
                setOpen(false);
              }}
            >
              RECUPERAR
            </Button>
            <Button variant="contained" onClick={handleClose}>
              CANCELAR
            </Button>
          </div>
        </Box>
      </Modal>
    </div>
  );
}
